<template>
  <div v-loading="loading">
    <ul class="list-group list-group-flush">
      <li
        class="list-group-item d-flex justify-content-between align-items-center"
        role="button"
        v-for="(chat, index) in chats"
        :key="index"
				@click="get_actual_chat(chat)"
      >
				{{ chat.sender }}
				<span class="badge badge-primary badge-pill" v-if="chat.to_read > 0">{{ chat.to_read }}</span>
			</li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState({
      loading: (state) => state.Chat.loading,
      chats: (state) => state.Chat.chats,
    }),
  },
  created() {
    this.get_all_chats();
  },
  methods: {
    ...mapActions({
			get_all_chats: "Chat/get_chats",
			get_actual_chat: "Chat/get_actual_chat",
			
    }),
  },
};
</script>
